import { APP_LINKS, COMPANY } from "../constants/site";
import { Seo } from "../components/site/Seo";
import { Reveal, SectionHead } from "../components/site/Shared";
import { Icon } from "../components/site/Icon";

const VALUES = [
  {
    icon: "Home",
    title: "Homes first",
    text: "HomeAligns is designed around how Indian households actually run — multiple properties, shared family responsibilities and the services every home needs.",
  },
  {
    icon: "Lock",
    title: "Private by design",
    text: "Your household records, documents and photos are private to your account. We do not sell personal data or use advertising SDKs in the app.",
  },
  {
    icon: "ShieldCheck",
    title: "Honesty over hype",
    text: "Estimates are labelled as estimates. Plans buy platform access, not promises. We'd rather earn your trust than your click.",
  },
];

export default function About() {
  return (
    <>
      <Seo
        title="About HomeAligns — Household Management for India"
        description="HomeAligns, operated by Dwellsync Technologies Private Limited, helps Indian households organise assets, documents, warranties, properties and home services in one place."
        path="/about"
      />
      <section className="container-site max-w-4xl py-20 lg:py-24">
        <Reveal>
          <p className="eyebrow mb-4">About HomeAligns</p>
          <h1 className="font-display text-[clamp(34px,4.5vw,58px)] font-semibold leading-[1.06] tracking-tight text-ink">
            Every home runs on a hundred small details. We keep them aligned.
          </h1>
          <p className="mt-6 text-base leading-relaxed text-ink/65 md:text-lg">
            HomeAligns is a household management platform for India. It helps you record and manage
            your household — properties, assets, documents, warranties and policies — sends
            reminders before things expire or fall due, and connects you with independent service
            professionals through bookings, service requests and a second-hand marketplace.
          </p>
        </Reveal>

        <div className="mt-16 grid gap-6 md:grid-cols-3">
          {VALUES.map((v, i) => (
            <Reveal key={v.title} delay={i + 1} className="card-site p-7">
              <span className="icon-tile">
                <Icon name={v.icon} className="h-5 w-5" />
              </span>
              <h2 className="mt-5 text-base font-bold text-ink">{v.title}</h2>
              <p className="mt-2 text-sm leading-relaxed text-ink/60">{v.text}</p>
            </Reveal>
          ))}
        </div>

        <Reveal className="mt-16 rounded-3xl border border-teal-deep/10 bg-white p-8 md:p-10">
          <SectionHead
            eyebrow="The company"
            title="Operated by Dwellsync Technologies."
          />
          <dl className="grid gap-6 text-sm md:grid-cols-2">
            <div>
              <dt className="font-mono text-xs font-semibold uppercase tracking-[0.14em] text-ink/45">Legal entity</dt>
              <dd className="mt-1.5 font-semibold text-ink">{COMPANY.operator}</dd>
              <dd className="mt-1 text-ink/60">CIN {COMPANY.cin}</dd>
            </div>
            <div>
              <dt className="font-mono text-xs font-semibold uppercase tracking-[0.14em] text-ink/45">Registered office</dt>
              <dd className="mt-1.5 text-ink/75">{COMPANY.address}</dd>
            </div>
            <div>
              <dt className="font-mono text-xs font-semibold uppercase tracking-[0.14em] text-ink/45">Support</dt>
              <dd className="mt-1.5">
                <a href={`mailto:${COMPANY.supportEmail}`} data-testid="about-support-email-link" className="font-bold text-teal-deep underline underline-offset-4 hover:text-teal">
                  {COMPANY.supportEmail}
                </a>
              </dd>
            </div>
            <div>
              <dt className="font-mono text-xs font-semibold uppercase tracking-[0.14em] text-ink/45">Product</dt>
              <dd className="mt-1.5 text-ink/75">{COMPANY.product} — {COMPANY.domain}</dd>
            </div>
          </dl>
        </Reveal>

        <Reveal className="mt-12">
          <a href={APP_LINKS.getStarted} data-testid="about-get-started-btn" className="btn-primary">
            Get Started <Icon name="ArrowRight" className="h-4 w-4" />
          </a>
        </Reveal>
      </section>
    </>
  );
}
